export default {
  modalHeader: {
    id: 'flash_sales_modal_header',
    defaultMessage: 'Flash deal',
  },
  modalImageUrl: {
    id: 'flash_sales_modal_image_url',
    defaultMessage:
      'https://flash-sale.statics.backmarket.com/category_images/{categoryId}/image.png',
  },
  modalTitle: {
    id: 'flash_sales_modal_title',
    defaultMessage: 'Flash Deal',
  },
  modalTagline: {
    id: 'flash_sales_modal_tagline',
    defaultMessage: 'Limited time only',
  },
  modalText: {
    id: 'flash_sales_modal_text',
    defaultMessage:
      'Now dad can read his texts in an even bigger font, for {price} off.',
  },
  modalDisclaimer: {
    id: 'flash_sales_modal_disclaimer',
    defaultMessage:
      'Promotion is automatically applied at checkout and cannot be combined with any other promotions.',
  },
  modalCta: {
    id: 'flash_sales_modal_cta',
    defaultMessage: 'Got it',
  },
  stickerTitle: {
    id: 'flash_sales_product_page_title_tag',
    defaultMessage: 'Get {price} off with limited Flash Deal',
  },
  stickerDescription: {
    id: 'flash_sales_product_page_description_tag',
    defaultMessage: 'Automatically applied at checkout.',
  },
} as const
